import ModelInterface from 'src/models/ModelInterface'
import {RawStudent} from '@/types/entity/RawStudent'
import store from '@/store/index'

// @ts-ignore
import messages from '@/lang/index';

class Student extends ModelInterface<RawStudent> {

  constructor (data: RawStudent) {
    super(data)
  }

  public getFirstName () {
    return this.data.first_name || '';
  }

  public getLastName () {
    return this.data.last_name || '';
  }

  public getMiddleName () {
    return this.data.middle_name || '';
  }

  public getFullName () {
    let fullName = ''
    fullName += this.data.last_name ? this.data.last_name + ' ' : ''
    fullName += this.data.first_name ? this.data.first_name + ' ' : ''
    fullName += this.data.middle_name ? this.data.middle_name + ' ' : ''
    return fullName;
  }

  public getMsgrs () {
    if (this.data.msgr && Object.keys(this.data.msgr).length && this.data.msgr.mgs.length) {
      return this.data.msgr
    } else {
      return false;
    }
  }

  public getSnils () {
    return this.data.stud.snils;
  }

  public getGringo () {
    return this.data.stud.gringo;
  }

  public getEmail () {
    return this.data.email;
  }

  public getPhones () {
    return this.data.phone || this.data.phones;
  }

  public getHash () {
    return this.data.stud.hash;
  }

  public getGroup () {
    return this.data.stud.group;
  }

  public getFinancing () {
    return this.data.stud.financing;
  }

  public getGroupGuid () {
    return this.data.stud.group_guid;
  }

  public getSpecialty () {
    return this.data.stud.speciality || this.data.stud.specialty || this.data.stud.specialization;
  }

  public getProfile () {
    return this.data.stud.profile;
  }

  public getSpecialty2 () {
    return this.data.stud.speciality2;
  }

  public getUid () {
    return this.data.stud.uid;
  }

  public getHalfYear () {
    return this.data.stud.half_year;
  }

  public getState () {
    return this.data.stud.state;
  }

  public getFaculty () {
    return this.data.stud.faculty;
  }

  public getLevel () {
    return this.data.stud.level;
  }

  public getTerm () {
    return this.data.stud.term;
  }

  public getYear () {
    return this.data.stud.year;
  }

  public getPid () {
    return this.data.stud.pid;
  }

  public getCourse () {
    return this.data.stud.course;
  }

  public getInn () {
    return this.data.stud.inn;
  }

  public getChanged () {
    return this.data.stud.changed;
  }

  public getForm () {
    return this.data.stud.form;
  }

  public getProgram () {
    return this.data.stud.program;
  }

  public getSemester () {
    return this.data.stud.semester;
  }

  public getId () {
    return this.data.id;
  }

  public getGuid () {
    return this.data.stud.guid || this.data.guid;
  }

  public getKub_id () {
    return this.data.stud.kub_id;
  }

  public getMessengers () {
    return '-';
  }

  public getDeleted () {
    const deleted = this.data.stud.deleted;

    if (deleted === true || deleted === 1) {
      return messages.labels.yes;
    }

    if (deleted === false || deleted === 0 || deleted === '') {
      return messages.labels.no;
    }

    return deleted;
  }

  public getForeigner () {
    const foreigner = this.data.stud.foreigner;

    if (foreigner === true || foreigner === 1) {
      return messages.labels.yes;
    }

    if (foreigner === false || foreigner === 0 || foreigner === '') {
      return messages.labels.no;
    }

    return foreigner;
  }

  // public getTel () {
  //   return this.data.stud.tel || '';
  // }

  public getBirthdate () {
    return this.getDate(this.data.birthdate);
  }

  public getPlaceOfBirth () {
    return this.data.stud.place_of_birth;
  }

  public getEdu_num () {
    return this.data.stud.edu_num;
  }

  public getEdu_date1 () {
    return this.getDate(this.data.stud.edu_date1);
  }

  public getEdu_date2 () {
    return this.getDate(this.data.stud.edu_date2);
  }

  public getEdu_date2_Fact () {
    return this.getDate(this.data.stud.edu_date2_fact);
  }

  public getTarget_enrollment () {
    return this.data.stud.target_enrollment;
  }

  public getTarget_organization () {
    return this.data.stud.target_organization;
  }

  public getPlan_code () {
    return this.data.stud.plan_code;
  }

  public getPlan_code2 () {
    return this.data.stud.plan_code2;
  }

  public getPlan_comment () {
    return this.data.stud.plan_comment;
  }

  public getPlan_cname () {
    return this.data.stud.plan_cname;
  }

  public getType_edu () {
    return this.data.stud.type_edu;
  }

  public getNeed_hostel () {
    if (this.data.stud.need_hostel === '0') {
      return messages.labels.no;
    } else if (this.data.stud.need_hostel === '1') {
      return messages.labels.yes;
    }
  }

  public getRussian_language () {
    if (this.data.stud.russian_language === '0') {
      return messages.labels.no;
    } else if (this.data.stud.russian_language === '1') {
      return messages.labels.yes;
    }
  }

  public getStatus () {
    return this.data.stud.status;
  }

  public getStatus_ay () {
    return this.data.stud.status_ay;
  }

  public getPlan_comment2 () {
    return this.data.stud.plan_comment2;
  }

  public getLatinLastName () {
    return this.data.stud.latin_last_name;
  }

  public getLatinMiddleName () {
    return this.data.stud.latin_middle_name;
  }

  public getLatinFirstName () {
    return this.data.stud.latin_first_name;
  }

  public getComment1 () {
    return this.data.stud.comment1;
  }

  public getComment2 () {
    return this.data.stud.comment2;
  }

  public getComment3 () {
    return this.data.stud.comment3;
  }

  public getComment_tu () {
    return this.data.stud.comment_tu;
  }

  public getGender () {
    if (this.data.gender === 'M') {
      return messages.labels.gender_male_short;
    } else if (this.data.gender === 'F') {
      return messages.labels.gender_female_short;
    }
  }

  public getCitizen () {
    return this.data.stud.citizen;
  }

  public getCn () {
    return this.data.stud.cn;
  }

  public getOu () {
    return this.data.stud.ou;
  }

  public getSyncTime () {
    return this.data.stud.sync_time;
  }

  public getDebtDate () {
    return this.data.stud.debt_date;
  }

  public getFilial () {
    return this.data.stud.filial;
  }

  public getDepart () {
    return this.data.stud.depart;
  }

  public getDirection () {
    return this.data.stud.direction;
  }

  public getProgAsp () {
    return this.data.stud.prog_asp;
  }

  public getProgMag () {
    return this.data.stud.prog_mag;
  }

  public getQualif () {
    return this.data.stud.qualif;
  }

  public getCompetition () {
    return this.data.stud.competition || this.data.stud.konkurs;
  }

  public getEdu_honors () {
    if (this.data.stud.edu_honors === '0') {
      return messages.labels.no;
    } else if (this.data.stud.edu_honors === '1') {
      return messages.labels.yes;
    }
  }

  public getAcademicYear () {
    return this.data.stud.year;
  }

  public getHostel () {
    return this.data.stud.hostel;
  }

  public getCards () {
    const cards = this.data.stud.cards;
    for (const card in cards) {
      const item = cards[card]
      // @ts-ignore
      for (var propName in item) {
        if (item[propName] === null || item[propName] === undefined || item[propName] === '') {
          delete item[propName];
        }
      }
    }
    return cards;
  }

  public hasComments () {
    const stud = this.data.stud;
    if (stud.plan_comment || stud.comment1 || stud.comment2 || stud.comment3 || stud.plan_comment2 || stud.comment_tu) {
      return true;
    }
    return false;
  }

  public hasContacts () {
    if (this.data.email || this.data.phones) {
      return true;
    }
    return false;
  }

  public hasGenericData () {
    const stud = this.data.stud;
    if (this.data.birthdate || stud.place_of_birth || stud.russian_language || this.data.gender || stud.citizen || stud.hostel) {
      return true;
    }
    return false;
  }

  public hasDocuments () {
    const stud = this.data.stud;
    if (stud.snils || stud.inn) {
      return true;
    }
    return false;
  }

  public hasSystemInfo () {
    const stud = this.data.stud;
    if (stud.id || stud.pid || (stud.guid || this.data.guid) || stud.kub_id || stud.deleted || stud.foreigner || stud.cn || stud.ou || stud.sync_time) {
      return true;
    }
    return false;
  }

  public hasEducationInfo () {
    const stud = this.data.stud;

    if (!stud) {
      return false
    }

    if (stud.form || stud.financing || stud.program || stud.state || stud.term || stud.level || stud.edu_num || stud.edu_date1 || stud.edu_date2 || stud.edu_date2_fact || stud.target_enrollment || stud.target_organization || stud.plan_code || stud.plan_cname || stud.plan_code2 || (stud.need_hostel === '0' || stud.need_hostel === '1') || stud.status || stud.status_ay || (stud.edu_honors === '0' || stud.edu_honors === '1') || stud.year || (stud.cards && stud.cards.length)) {
      return true;
    }
    return false;
  }

  public hasDebtInfo () {
    const stud = this.data.stud;
    if (stud.debt_date) {
      return true;
    }
    return false;
  }

  public isAuth () {
    return '-';
  }

  private getDate (date: string | undefined) {
    if (!date) {
      return date;
    }

    let newDate;

    if (date && date.length === 10 && date.indexOf('-') === 4 && date.indexOf('-', 5) === 7) {
      newDate = date.split('-');

      if (newDate[1] === '01') {
        newDate[1] = messages.labels.months1['1']
      } else if (newDate[1] === '02') {
        newDate[1] = messages.labels.months1['2']
      } else if (newDate[1] === '03') {
        newDate[1] = messages.labels.months1['3']
      } else if (newDate[1] === '04') {
        newDate[1] = messages.labels.months1['4']
      } else if (newDate[1] === '05') {
        newDate[1] = messages.labels.months1['5']
      } else if (newDate[1] === '06') {
        newDate[1] = messages.labels.months1['6']
      } else if (newDate[1] === '07') {
        newDate[1] = messages.labels.months1['7']
      } else if (newDate[1] === '08') {
        newDate[1] = messages.labels.months1['8']
      } else if (newDate[1] === '09') {
        newDate[1] = messages.labels.months1['9']
      } else if (newDate[1] === '10') {
        newDate[1] = messages.labels.months1['10']
      } else if (newDate[1] === '11') {
        newDate[1] = messages.labels.months1['11']
      } else if (newDate[1] === '12') {
        newDate[1] = messages.labels.months1['12']
      }

      newDate = newDate[2] + ' ' + newDate[1] + ' ' + newDate[0] + ' ' + messages.labels.year_short
    } else {
      newDate = date
    }

    return newDate
  }
}

export default Student